import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputSelect from '../InputSelect';
import AppLayout from '../AppLayout';
import { storeReward, getReward, listMarketplace } from '../../Api';
import FormErrors from '../FormErrors'
import { format } from '../../share/date'

class RewardForm extends Component {
  state = {
    value: 0,
    repet: 0,
    marketplace: {},
    marketplaces: [],
    lottery: {},
    lotteries: [],
    error: {},
    isManual: false,
    qr: '',
  };

  async componentDidMount() {

    const marketplaces = await listMarketplace(this.props.usuario.token)
    if (marketplaces && marketplaces.length > 0) {
      const marketplace = marketplaces[0]
      this.setState({ marketplaces });
      this.setLottery(marketplace);
    }

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      const { id } = this.props.match.params;
      let { active, qr, lottery, marketplace } = await getReward(id, this.props.usuario.token)
      this.setState({ id, qr, active, marketplace, lottery })
    }

  }

  handleSubmit = async event => {
    event.preventDefault();
    let data = {
      value: this.state.value,
      repet: this.state.repet,
      lottery: this.state.lottery._id,
    }
    if (this.state.isManual) {
      data.repet = 1
      data.qr = this.state.qr
    }
    try {
      await this.store(data)
    } catch (error) {
      if (typeof error === 'string') {
        this.setState({ error: { name: 'Error', message: error } })
      } else {
        this.setState({ error })
      }
    }
  };

  setLottery(marketplace) {
    const lotteries = marketplace.lotteryList || [];
    const lottery = lotteries && lotteries.length > 0 ? lotteries[0] : {};
    this.setState({ marketplace, lotteries, lottery });
  }

  async store(data) {
    const res = await storeReward(data, this.props.usuario.token);
    if (Array.isArray(res)) {
      this.props.history.push('/rewards');
    } else {
      alert(JSON.stringify(res))
    }
  }

  onInputChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const id = target.id;
    this.setState({ [id]: value });
    document.getElementById(id).classList.remove("is-danger");
  };

  render() {
    return (
      <AppLayout>
        <h1>Premio</h1>
        <form className='form'>
          <FormErrors {...this.state.error} />
          <div className='form-group'>
            <div className='checkbox'>
              <label className="">
                <input
                  className="checkbox"
                  type="checkbox"
                  id='isManual'
                  checked={this.state.isManual}
                  onChange={this.onInputChange}
                />
                Manual
              </label>
            </div>
          </div>

          <div className='row'>
            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor="value">Valor</label>
                <input
                  className="form-control"
                  id='value'
                  type='numeric'
                  value={this.state.value}
                  onChange={this.onInputChange}
                />
              </div>
            </div>
            {this.state.isManual ? (
              <div className="col-md-6">
                <div className='form-group'>
                  <label htmlFor="value">QR</label>
                  <input
                    className="form-control"
                    id='qr'
                    type='string'
                    value={this.state.qr}
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
            ) : (
              <div className="col-md-6">
                <div className='form-group'>
                  <label htmlFor="repet">Cantidad</label>
                  <input
                    className="form-control"
                    id='repet'
                    type='numeric'
                    repet={this.state.repet}
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
            )}

          </div>




          <div className='form-group'>
            <InputSelect
              keyField="_id"
              label="Plazas"
              readOnly={this.props.readOnly}
              row={this.state.marketplace}
              rows={this.state.marketplaces}
              format={(data) => { return data.name }}
              onChange={(data) => { this.setLottery(data) }}
            />
          </div>
          <div className='form-group'>
            <InputSelect
              keyField="_id"
              label="Sorteos"
              readOnly={this.props.readOnly}
              row={this.state.lottery}
              rows={this.state.lotteries}
              format={(data) => {
                const date = data.created_at ? format({ date: data.created_at }) : ''
                const actived = data.active ? 'SI' : 'NO'
                return `${date} - ${actived}`
              }}
              onChange={(data) => { this.setState({ lottery: data }) }}
            />
          </div>
          <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>Guardar</button>
        </form>
      </AppLayout>
    );
  }
}

const mapStoreToProps = (state, props) => {
  return {
    ...props,
    usuario: state.usuario,
  }
}
export default withRouter(connect(mapStoreToProps)(RewardForm));